import { useEffect, useState } from 'react';
import '../assets/css/style.css';

const useScrollAnimation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const animatedElements = document.querySelectorAll('.animate-fade, .animate-up');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.1 }
    );

    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrolled; // Devuelve si está scrolleado o no
};

export default useScrollAnimation;
